export const initialFullServiceValues = {
  programmingComplexity: "",
  dataProcess: false,
  translation: false,
  numberOfQuestions: ""
}